import styled, {css} from "styled-components";

interface IBottomStickyNavbarContainerBoxProps {
  shouldElevate: boolean;
}

export const BottomStickyNavbarContainerDefaultBox = styled.div<IBottomStickyNavbarContainerBoxProps>`
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: ${props => props.theme.colors.backgroundDark};
  border-top: 1.4px ${props => props.theme.colors.brandPrimary} solid;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 101;

  ${props => props.shouldElevate && css`
    z-index: 115;
  `}
`;
